import React from "react";

import learnLogo from "../../assets/icons/logos/learnLogo.svg";
import scaLogo from "../../assets/icons/logos/scaLogo.svg";
import { useHeaderContext } from "../../context/HeaderContext";
import styles from "./HeaderNavbar.module.scss";
import { SCA_VERTICAL_ID } from "../../constants/constants";

const logoByVertical = {
  1: learnLogo,
  2: scaLogo,
};

const HeaderNavbar = () => {
  const { verticalId } = useHeaderContext();
  const logo = logoByVertical[verticalId] || learnLogo;
  const logoClassName =
    verticalId === SCA_VERTICAL_ID
      ? `${styles.logo} ${styles.scaLogo}`
      : `${styles.logo} ${styles.learnLogo}`;

  return (
    <div className={styles.logoWrap}>
      <img src={logo} alt="Business logo" className={logoClassName} />
    </div>
  );
};

export default HeaderNavbar;